import { useMemo } from 'react';
import { Permission, type PermissionValue } from '../../auth/types';

/**
 * Maps user permissions to group tags used in scheduler attendees
 * 
 * Examples:
 * - SELF_CHECK_IN → 'cast'
 * - EDIT_COSTUMES → 'costumes'
 * - EDIT_SOUND → 'sound'
 */
export function useMemberGroups(permissions: PermissionValue[]): string[] {
    return useMemo(() => {
        const groups: string[] = [];

        if (permissions.includes(Permission.SELF_CHECK_IN)) {
            groups.push('cast');
        }
        if (permissions.includes(Permission.EDIT_COSTUMES)) {
            groups.push('costumes');
        }
        if (permissions.includes(Permission.EDIT_PROPS)) {
            groups.push('props');
        }
        if (permissions.includes(Permission.EDIT_SOUND)) {
            groups.push('sound');
        }
        if (permissions.includes(Permission.EDIT_RUNSHEET)) {
            groups.push('crew', 'sm');
        }
        if (permissions.includes(Permission.EDIT_SCHEDULER)) {
            groups.push('director', 'production');
        }
        if (permissions.includes(Permission.MANAGE_USERS)) {
            groups.push('production', 'admin');
        }

        return groups;
    }, [permissions]);
}
